export default "__VITE_ASSET__CUwDh0UE__"